const page_404 = {
	description: "De pagina die u zocht kan niet gevonden worden.",
	home_button: "Ga naar de homepagina",
	title: "404 Error",
};

export default page_404;
